// Dark Admin UI Color Palette - Style Guide Compliant
export const DARK_BG = "#020817"; // Main content (right side) background
export const DARK_BG_SECONDARY = "#18181b"; // Left sidebar background
export const DARK_BG_TERTIARY = "#27272a"; // Sidebar hover / active background
export const DARK_SURFACE = "#232E4F"; // Elevated surface (legacy - avoid use)

export const GREY = "#4A5A7F";
export const GREY_DARK = "#2D3A54";
export const GREY_DARK_SECOND = "#3D4F6E";
export const GREY_LIGHT = "#6B7A9E";

export const BLACK = "#000000";

export const DARK_COLOR = "#020817";
export const DARK_COLOR_SECOND = "#0F1429";

// Brand Accent Color - Use only for primary actions and critical highlights
export const SECONDARY = "#ff6161"; // Coral accent
export const ACCENT_PURPLE = "#B026FF"; // Legacy - avoid use
export const ACCENT_LIME = "#39FF14"; // Legacy - avoid use

// Status Colors
export const ACCEPT_COLOR = "#00D9FF"; // Cyan for success
export const CANCEL_COLOR = "#FF006E"; // Magenta for error

// Text Colors - Exact values per style guide
export const TEXT_PRIMARY = "#f8fafc"; // Primary emphasis text (important values)
export const TEXT_SECONDARY = "#94a3b8"; // Primary table text (secondary information)
export const TEXT_TERTIARY = "#94a3b8"; // Primary table text (secondary information)

// Border Colors
export const BORDER_COLOR = "rgba(148, 163, 184, 0.1)"; // Subtle separator
export const BORDER_COLOR_LIGHT = "rgba(148, 163, 184, 0.1)"; // Subtle separator

export const TABLE_HOVER = "#0d1525"; // Table row hover background

export const MAIN_THEME = {
	GREY,
	GREY_DARK,
	GREY_LIGHT,
	BLACK,
	DARK_COLOR,
	DARK_COLOR_SECOND,
	ACCEPT_COLOR,
	CANCEL_COLOR,
	GREY_DARK_SECOND,
	DARK_BG,
	DARK_BG_SECONDARY,
	DARK_BG_TERTIARY,
	DARK_SURFACE,
	SECONDARY,
	ACCENT_PURPLE,
	ACCENT_LIME,
	TEXT_PRIMARY,
	TEXT_SECONDARY,
	TEXT_TERTIARY,
	BORDER_COLOR,
	BORDER_COLOR_LIGHT,
	TABLE_HOVER,
};
